const transfer = require('@/apps/transfer/api/transfer');

let api = {};

Object.assign(api, transfer.default)

export default api;
